/* @generated */

// src/assets/ui-icon/line/edit.tsx
import * as React from "react";
var EditLine = (props) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", fill: "none", ...props }, /* @__PURE__ */ React.createElement(
  "path",
  {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.988 7.139c0 .597-.236 1.169-.657 1.591l-7.114 7.109-4.25.691.692-4.25 7.111-7.11a2.252 2.252 0 0 1 3.182 0l.378.379c.422.422.659.994.659 1.591Zm-1.718-.53-.378-.379a.752.752 0 0 0-1.063 0l-.796.796 1.45 1.43.787-.787a.75.75 0 0 0 0-1.06ZM8.062 13l-.28 1.717 1.718-.279 4.923-4.919-1.45-1.43L8.062 13Z",
    fill: "currentColor",
    vectorEffect: "non-scaling-stroke"
  }
), /* @__PURE__ */ React.createElement("path", { d: "M5 18h14v1.5H5V18Z", fill: "currentColor", vectorEffect: "non-scaling-stroke" }));
export {
  EditLine
};
